import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. Reset the window scroll instantly
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // 'smooth' can sometimes fail to reach the very top
    });

    // 2. Fallback for stubborn layouts (like if 'main' or 'body' is scrolling)
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;